export default "__VITE_ASSET__CPmy2pCI__"